import { useUserContext, HelmetDexteel } from "@dexteel/mesf-core";
import { useNavigate, useParams } from "react-router-dom";
import { WorkOrdersProvider } from "./context/workOrdersContext";
import { useInitialValues } from "./filters/hooks/useInitialValues";
import WorkOrders from "./WorkOrders";

type Props = {};

const WorkOrdersPage = (props: Props) => {
	const navigate = useNavigate();
	const { AssetIdParam } = useParams();
	const {
		state: { defaultAreaId },
	} = useUserContext();

	useInitialValues();

	if (!AssetIdParam) {
		navigate(`/work-orders/${defaultAreaId}`);
	}

	return (
		<>
			<HelmetDexteel title="Work Orders" />
			<WorkOrdersProvider>
				<WorkOrders />
			</WorkOrdersProvider>
		</>
	);
};

export default WorkOrdersPage;
